export type TournamentStatus = 'setup' | 'in_progress' | 'completed';
export type TournamentType = 'single_elimination' | 'double_elimination' | 'round_robin' | 'swiss' | 'triple_elimination' | 'king_of_the_hill';

export interface Tournament {
  id: string;
  name: string;
  description?: string;
  tournamentType: TournamentType;
  status: TournamentStatus;
  maxParticipants?: number;
  createdAt: Date;
  updatedAt: Date;
  userId: string;
  isPublic?: boolean;
  rules?: string;
  location?: string;
  locationLat?: number;
  locationLng?: number;
  startDate?: Date;
  leagueId?: string;
  inviteCode?: string;
}
